import { defaultStatus } from "../../screen/constant/defaultStatus";
import {
  BARCLUB_ADD_REQUEST,
  BARCLUB_ADD_SUCCESS,
  BARCLUB_ADD_FAILURE,
  BARCLUB_EDIT_REQUEST,
  BARCLUB_EDIT_SUCCESS,
  BARCLUB_EDIT_FAILURE,
  BARCLUB_VIEW_REQUEST,
  BARCLUB_VIEW_SUCCESS,
  BARCLUB_VIEW_FAILURE,
  BARCLUB_VIEW_ALL_REQUEST,
  BARCLUB_VIEW_ALL_SUCCESS,
  BARCLUB_VIEW_ALL_FAILURE,
  BARCLUB_DELETE_REQUEST,
  BARCLUB_DELETE_SUCCESS,
  BARCLUB_DELETE_FAILURE,
  BARCLUB_RESET_STATE,
  BARCLUB_SEARCH_REQUEST,
  BARCLUB_SEARCH_SUCCESS,
  BARCLUB_SEARCH_FAILURE,
  BARCLUB_VIEW_ALL_BY_WHOLESALERID_REQUEST,
  BARCLUB_VIEW_ALL_BY_WHOLESALERID_SUCCESS,
  BARCLUB_VIEW_ALL_BY_WHOLESALERID_FAILURE,
  BARCLUB_WHOLESALERID_SEARCH_REQUEST,
  BARCLUB_WHOLESALERID_SEARCH_SUCCESS,
  BARCLUBL_WHOLESALERID_SEARCH_FAILURE,
} from "./BarClubTypes";

const initialState = {
  addBarClub: { ...defaultStatus },
  editBarClub: { ...defaultStatus },
  deleteBarClub: { ...defaultStatus },
  viewBarClub: { ...defaultStatus },
  viewAllBarClub: { ...defaultStatus },
  viewAllWholesalerBarClub: { ...defaultStatus },
  viewAllSearchBarClub: { ...defaultStatus },
  viewAllBarClubByWholesalerId: { ...defaultStatus },
  viewAllSearchBarClubByWholesalerId: { ...defaultStatus },
};

const BarClubReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    // Add Bar/Club Cases
    case BARCLUB_ADD_REQUEST:
      return {
        ...state,
        addBarClub: { ...defaultStatus, inProgress: true, ...payload },
      };
    case BARCLUB_ADD_SUCCESS:
      return {
        ...state,
        addBarClub: { ...defaultStatus, success: true, ...payload },
      };
    case BARCLUB_ADD_FAILURE:
      return {
        ...state,
        addBarClub: { ...defaultStatus, error: true, ...payload },
      };

    // Edit Bar/Club Cases
    case BARCLUB_EDIT_REQUEST:
      return {
        ...state,
        editBarClub: { ...defaultStatus, inProgress: true, ...payload },
      };
    case BARCLUB_EDIT_SUCCESS:
      return {
        ...state,
        editBarClub: { ...defaultStatus, success: true, ...payload },
      };
    case BARCLUB_EDIT_FAILURE:
      return {
        ...state,
        editBarClub: { ...defaultStatus, error: true, ...payload },
      };

    // View Bar/Club Cases
    case BARCLUB_VIEW_REQUEST:
      return {
        ...state,
        viewBarClub: { ...defaultStatus, inProgress: true, ...payload },
      };
    case BARCLUB_VIEW_SUCCESS:
      return {
        ...state,
        viewBarClub: { ...defaultStatus, success: true, ...payload },
      };
    case BARCLUB_VIEW_FAILURE:
      return {
        ...state,
        viewBarClub: { ...defaultStatus, error: true, ...payload },
      };

    // View All Bars/Clubs Cases
    case BARCLUB_VIEW_ALL_REQUEST:
      return {
        ...state,
        viewAllBarClub: { ...defaultStatus, inProgress: true, ...payload },
      };
    case BARCLUB_VIEW_ALL_SUCCESS:
      return {
        ...state,
        viewAllBarClub: { ...defaultStatus, success: true, ...payload },
      };
    case BARCLUB_VIEW_ALL_FAILURE:
      return {
        ...state,
        viewAllBarClub: { ...defaultStatus, error: true, ...payload },
      };

    // View All Search Bars/Clubs Cases
    case BARCLUB_SEARCH_REQUEST:
      return {
        ...state,
        viewAllSearchBarClub: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case BARCLUB_SEARCH_SUCCESS:
      return {
        ...state,
        viewAllSearchBarClub: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case BARCLUB_SEARCH_FAILURE:
      return {
        ...state,
        viewAllSearchBarClub: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    // View All Bars/Clubs By Wholesaler Id Cases
    case BARCLUB_VIEW_ALL_BY_WHOLESALERID_REQUEST:
      return {
        ...state,
        viewAllBarClubByWholesalerId: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case BARCLUB_VIEW_ALL_BY_WHOLESALERID_SUCCESS:
      return {
        ...state,
        viewAllBarClubByWholesalerId: {
          ...defaultStatus,
          success: true,
          ...payload,
        },
      };
    case BARCLUB_VIEW_ALL_BY_WHOLESALERID_FAILURE:
      return {
        ...state,
        viewAllBarClubByWholesalerId: {
          ...defaultStatus,
          error: true,
          ...payload,
        },
      };

    // View All Search Bars/Clubs By Wholesaler Id Cases
    case BARCLUB_WHOLESALERID_SEARCH_REQUEST:
      return {
        ...state,
        viewAllSearchBarClubByWholesalerId: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case BARCLUB_WHOLESALERID_SEARCH_SUCCESS:
      return {
        ...state,
        viewAllSearchBarClubByWholesalerId: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case BARCLUBL_WHOLESALERID_SEARCH_FAILURE:
      return {
        ...state,
        viewAllSearchBarClubByWholesalerId: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    // Delete Bar/Club Cases
    case BARCLUB_DELETE_REQUEST:
      return {
        ...state,
        deleteBarClub: { ...defaultStatus, inProgress: true, ...payload },
      };
    case BARCLUB_DELETE_SUCCESS:
      return {
        ...state,
        deleteBarClub: { ...defaultStatus, success: true, ...payload },
      };
    case BARCLUB_DELETE_FAILURE:
      return {
        ...state,
        deleteBarClub: { ...defaultStatus, error: true, ...payload },
      };

    // Reset State Case
    case BARCLUB_RESET_STATE:
      return {
        ...initialState,
      };

    // Default Case
    default:
      return state;
  }
};

export default BarClubReducer;
